var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(-134 -135)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M38.5,0A38.5,38.5,0,1,1,0,38.5,38.5,38.5,0,0,1,38.5,0Z",
    transform: "translate(134 135)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "download_5_",
    "data-name": "download (5)",
    transform: "translate(153 154.61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M432.379,335.293H428.1v1.223H433.6v-5.5H432.38Z",
    transform: "translate(-394.081 -295.901)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M255.448,378.84a12.072,12.072,0,0,1-13.362,0c-4.652.44-8.165,2.824-8.165,5.721v7.628h29.692v-7.628C263.613,381.664,260.1,379.28,255.448,378.84Z",
    transform: "translate(-229.595 -357.079)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M323.315,225.106a9.174,9.174,0,1,1-9.175-9.175,9.174,9.174,0,0,1,9.175,9.175",
    transform: "translate(-295.033 -214.28)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M286.794,332.923h-4.281v-4.281h-1.223v5.5h5.5Z",
    transform: "translate(-281.288 -293.531)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M282.51,202h4.281v-1.223h-5.5v5.5h1.223Z",
    transform: "translate(-281.287 -200.777)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M432.379,208.653H433.6v-5.5H428.1v1.223h4.281Z",
    transform: "translate(-394.08 -203.149)",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 40,
    height: 2,
    rx: 1,
    transform: "translate(153 169)",
    fill: "#c9c4c4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPic);
export default __webpack_public_path__ + "static/media/pic.f7be1f115a9dfa9e27099813b7a24ddb.svg";
export { ForwardRef as ReactComponent };